/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { SettingResponse } from '../../models/setting-response';

export interface GetSiteSettings$Params {
  organizationSiteKey: KeyType;
}

export function getSiteSettings(http: HttpClient, rootUrl: string, params: GetSiteSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingResponse>> {
  const rb = new RequestBuilder(rootUrl, getSiteSettings.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingResponse>;
    })
  );
}

getSiteSettings.PATH = '/organization-sites/{organizationSiteKey}/settings';
